/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_DayInputs */

const en_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day`)
};

const fr_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jour`)
};

const de_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const it_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorno`)
};

const ru_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`День`)
};

const es_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Día`)
};

const zh_cn2_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`天`)
};

const ja_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日`)
};

const hi_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दिन`)
};

const pt_pt2_usage_day = /** @type {(inputs: Usage_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia`)
};

/**
* | output |
* | --- |
* | "Day" |
*
* @param {Usage_DayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_day = /** @type {((inputs?: Usage_DayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_DayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_day(inputs)
	if (locale === "de") return de_usage_day(inputs)
	if (locale === "it") return it_usage_day(inputs)
	if (locale === "ru") return ru_usage_day(inputs)
	if (locale === "es") return es_usage_day(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_day(inputs)
	if (locale === "ja") return ja_usage_day(inputs)
	if (locale === "hi") return hi_usage_day(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_day(inputs)
	return en_usage_day(inputs)
});